export default "__VITE_ASSET__AbdzoNH4__"